import CompletedVisits from './CompletedVisits'
import FutureVisits from './FutureVisits'

export default function VisitsPage() {
  return (
    <div className="container">
      <div className="row" style={{ marginBottom: 60, marginTop: 40 }}>
        <div>
          <h3 style={{ marginBottom: -3 }}>Completed Visits</h3>
          <p style={{ marginBottom: 14, fontSize: '80%' }}>Source: Sitetool</p>
          <CompletedVisits />
          <p className="mt-1 text-muted" style={{ fontSize: '70%' }}>
            Note for non-Sanos sites: The count is based on date of event registration in Sitetool - not actual date.
          </p>
        </div>
      </div>
      <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
        <div>
          <h3 style={{ marginBottom: -3 }}>Future Visits</h3>
          <p style={{ marginBottom: 14, fontSize: '80%' }}>Source: Clinical Conductor</p>
          <FutureVisits />
          <p className="mt-4 text-muted" style={{ fontSize: '70%' }}>
            Note:
            <br />
            1. Only visits containing "rando" or "screening" in the name is included.
            <br />
            2. The column order is screening's in alphabetically order and lastly rando's
          </p>
        </div>
        <div className="row" style={{ marginBottom: 100, marginTop: 200 }}></div>
      </div>
    </div>
  )
}
